import React from "react";
import LegalPage from "../../components/LegalPage";
import { getViewTermsConditionList } from "../../services/TermsConditionService";
import useSeo from "../../utils/useSeo";

const TermsCondition = () => {
  useSeo({
    title: "Termos & Condições",
    description:
      "Termos e condições de utilização da plataforma TP Software. Regras, obrigações e direitos aplicáveis aos utilizadores do software de gestão de centros de abate automóvel.",
    keywords: "termos e condições, termos de utilização, TP Software, contrato de utilização",
    path: "/terms-condition",
  });

  return (
    <LegalPage
      eyebrow="Documento Legal"
      title="Termos & Condições"
      subtitle="As regras que regem a utilização da plataforma TP Software pelos nossos clientes e utilizadores."
      fetcher={getViewTermsConditionList}
      emptyMessage="Os Termos e Condições serão publicados em breve."
    />
  );
};

export default TermsCondition;
